export default () => {
  return {
    timeFrames: [],
    selectedTimeFrame: {},
    startDate: null,
    endDate: null,
    applied: false,
    applicable: true,
    cachedTimeFrame: null
  }
}
